module.exports = __webpack_public_path__ + "static/sea_hag-a1615213bb9a188f33519244404adde9.jpeg";